var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "26",
        viewBox: "0 0 17 26",
        width: "17",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { fill: "#48B6E7", "fill-rule": "nonzero" } }, [
        _c("path", {
          attrs: {
            d: "M8.415 9.037a4.51 4.51 0 0 0-3.614 7.218 2.26 2.26 0 0 1 2.259-2.248h.014a2.26 2.26 0 1 1 2.683 0h.014a2.26 2.26 0 0 1 2.259 2.248 4.51 4.51 0 0 0-3.615-7.218z",
          },
        }),
        _vm._v(" "),
        _c("circle", { attrs: { cx: "8.415", cy: "12.199", r: "1.355" } }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M9.77 14.91H7.06c-.749 0-1.356.607-1.356 1.356v.895a4.484 4.484 0 0 0 5.422 0v-.895c0-.749-.607-1.356-1.355-1.356zM16.973 0h-3.852L9.054 4.066l.452.452h3.232zM.018 0l6.325 6.326h3.693L3.71 0z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M16.096 6.777c0-.748-.607-1.355-1.355-1.355H10.41l.903.904h1.62a.452.452 0 1 1 0 .903H3.898a.452.452 0 1 1 0-.903h1.168l-.903-.904H2.09c-.749 0-1.356.607-1.356 1.355v17.17c0 .748.607 1.355 1.356 1.355h12.65c.75 0 1.356-.607 1.356-1.355V6.777zM12.03 23.495H4.8a.452.452 0 1 1 0-.904h7.23a.452.452 0 0 1 0 .904zm0-1.807H4.8a.452.452 0 1 1 0-.904h7.23a.452.452 0 1 1 0 .904zm-3.615-2.711a5.422 5.422 0 1 1 0-10.844 5.422 5.422 0 0 1 0 10.844z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }